import type {
  ImportModel,
  OnboardImportListModel,
  OnboardImportModel,
  OnboardImportRepLineItemModel,
  OnboardImportStaffLineItemModel,
} from '../app/types/onboard-import.type.ts';
import baseApi, { CacheTag } from './meeting-md-api-slice';

const onboardImportApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    fetchAllOnboardImports: builder.query<OnboardImportListModel[], void>({
      query() {
        return '/Onboard';
      },
      providesTags: [CacheTag.OnboardImport],
    }),
    fetchOnboardImport: builder.query<OnboardImportModel, string>({
      query(key) {
        return `/Onboard/${key}`;
      },
      providesTags: [CacheTag.OnboardImport],
    }),
    postOnboardImport: builder.mutation<OnboardImportModel, ImportModel>({
      query: post => ({
        url: '/Onboard',
        method: 'POST',
        body: post,
      }),
      invalidatesTags: [CacheTag.OnboardImport],
    }),
    deleteOnboardImport: builder.mutation<void, string>({
      query: key => ({
        url: `/Onboard/${key}`,
        method: 'DELETE',
      }),
      invalidatesTags: [CacheTag.OnboardImport],
    }),
    postOnboardImportSendRepEmails: builder.mutation<void, OnboardImportRepLineItemModel[]>({
      query: post => ({
        url: `/Onboard/SendRepEmails`,
        method: 'POST',
        body: post,
      }),
      invalidatesTags: [CacheTag.OnboardImport],
    }),
    postOnboardImportSendStaffEmails: builder.mutation<void, OnboardImportStaffLineItemModel[]>({
      query: post => ({
        url: `/Onboard/SendStaffEmails`,
        method: 'POST',
        body: post,
      }),
      invalidatesTags: [CacheTag.OnboardImport],
    }),
    fetchTimeZones: builder.query<any[], void>({
      query() {
        return '/onboard/timeZones';
      },
    }),
  }),
});

export const {
  useFetchAllOnboardImportsQuery,
  useFetchOnboardImportQuery,
  usePostOnboardImportMutation,
  useDeleteOnboardImportMutation,
  usePostOnboardImportSendRepEmailsMutation,
  usePostOnboardImportSendStaffEmailsMutation,
  useFetchTimeZonesQuery,
} = onboardImportApi;
